import { Info } from '@mui/icons-material'
import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Paper,
  Stack,
  Tooltip,
  Typography
} from '@mui/material'
import dayjs from 'dayjs'
import { useContext } from 'react'

import theme from '../../../styles/theme'
import { MaintenanceScheduleWithRecommendationWithEntry } from './AiHighlights'
import { MaintenanceScheduleContext } from './MaintenanceScheduleProvider'

export const RecommendationCard = ({
  recommendation
}: {
  recommendation: MaintenanceScheduleWithRecommendationWithEntry
}) => {
  const { selected, setSelected } = useContext(MaintenanceScheduleContext)
  const id = recommendation.entry!.laborApplication!.id!
  const selectedIds = selected?.map((s) => s.id!) || []
  const reason = recommendation.date
    ? `${recommendation.services}: performed${
        recommendation.mileage ? ' at mileages ' + recommendation.mileage : ' '
      } on ${dayjs(recommendation.date).format('MM/DD/YYYY')}`
    : 'No CarFax records found for this service.'

  const milesInterval = recommendation.entry!.timingInfoList!.intervalMile
    ? recommendation.entry!.timingInfoList!.frequencyDescription +
      ' ' +
      recommendation.entry!.timingInfoList!.intervalMile +
      ' Miles'
    : ''
  const monthInterval = recommendation.entry!.timingInfoList!.intervalMonth
    ? recommendation.entry!.timingInfoList!.frequencyDescription +
      ' ' +
      recommendation.entry!.timingInfoList!.intervalMonth +
      ' Months'
    : ''
  return (
    <Paper
      sx={{
        minWidth: 200,
        border: `1px solid ${theme.palette.primary.main}`,
        p: 2
      }}>
      <Stack spacing={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedIds?.includes(id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelected([
                    ...(selected || []),
                    recommendation.entry!.laborApplication!
                  ])
                } else {
                  setSelected([...(selected || []).filter((p) => p.id !== id)])
                }
              }}
            />
          }
          label={
            recommendation.entry.laborApplication?.taxonomy?.literalName +
            (recommendation.entry.laborApplication?.positionName
              ? ` (${recommendation.entry.laborApplication.positionName})`
              : '')
          }
        />
        <Box>
          <Tooltip title={reason}>
            <Chip
              label="Recommended"
              variant="outlined"
              color="info"
              onDelete={() => {}}
              deleteIcon={<Info />}
            />
          </Tooltip>
          {recommendation.entry!.timingInfoList!.severeServiceDescription ===
            'Yes' && <Chip label="Severe" variant="outlined" color="error" />}
        </Box>
        <Typography variant="body2" color="grey">
          {[milesInterval, monthInterval].filter((p) => p).join(' or ')}
        </Typography>
      </Stack>
    </Paper>
  )
}
